
const RESET_PASSWORD_RULE_ACTIONS = {
  SUCCESS: 'success',
  ERROR: 'error',
  PASS: 'pass',
  SET_INITIAL_DATA: 'set-data',
  CHECK_LENGTH: 'check-length',
  CHECK_UPPER_CASE: 'check-upper-case',
  CHECK_LOWER_CASE: 'check-lower-case',
  CHECK_NUMBER: 'check-number',
  CHECK_SPECIAL_CHARACTER: 'check-special-character',
  CHECK_HAS_SPECIAL_CHARACTER: 'check-has-special-character',
  CHECK_CHARACTER_TYPE: 'check-character-type',
  CHECK_ID_NAME: 'check-id-name',
  CHECK_PASSWORD_HISTORY: 'check-password-history'
};

const resetPasswordRuleReducer = (state, action) => {
  /**
  {
    lengthCheck: false,
    // 3 of 4 checkers 
    characterCheck: {
      uppercaseCheck: false,
      lowercaseCheck: false,
      numberCheck: false,
      //: ! @ # $ % & * ( ) _ = + - [ ] ?
      specialCharCheck: false,
      hasSpecialCharCheck: false
    },
    idNameCheck: false,
    historyCheck: false
  }*/

  let charCheckObj = state.characterCheck;

  switch (action.type) {
    case RESET_PASSWORD_RULE_ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        lengthCheck: false,
        // 3 of 4 checkers 
        characterCheck: {
          uppercaseCheck: false,
          lowercaseCheck: false,
          numberCheck: false,
          //: ! @ # $ % & * ( ) _ = + - [ ] ?
          specialCharCheck: false
        },
        idNameCheck: false,
        historyCheck: false
      };
    }
    case RESET_PASSWORD_RULE_ACTIONS.CHECK_LENGTH: {

      return {
        ...state,
        lengthCheck: action.value
      }
    }
    case RESET_PASSWORD_RULE_ACTIONS.CHECK_UPPER_CASE: {

      charCheckObj.uppercaseCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_LOWER_CASE: {

      charCheckObj.lowercaseCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_NUMBER: {

      charCheckObj.numberCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_SPECIAL_CHARACTER: {

      charCheckObj.specialCharCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_HAS_SPECIAL_CHARACTER: {

      charCheckObj.hasSpecialCharCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_ID_NAME: {

      return {
        ...state,
        idNameCheck: action.value
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.CHECK_PASSWORD_HISTORY: {

      return {
        ...state,
        historyCheck: action.value
      }
    }

    case RESET_PASSWORD_RULE_ACTIONS.PASS: {

      return {
        lengthCheck: true,
        characterCheck: {
          uppercaseCheck: true,
          lowercaseCheck: true,
          numberCheck: true,
          specialCharCheck: true
        },
        idNameCheck: true,
        historyCheck: true
      }
    }
  }
}

export { RESET_PASSWORD_RULE_ACTIONS, resetPasswordRuleReducer };